import { type SxProps, Tooltip } from '@mui/material';
import { type ReactNode, useState } from 'react';

import { SpanWithEllipsis } from './SpanWithEllipsis.js';

interface Props {
  tooltipMaxWidth?: number;
  placement?: 'left' | 'right';
  children?: ReactNode;
  sx?: SxProps;
}

export function SpanWithEllipsisAndTooltipOnOverflow(props: Props) {
  const { children, tooltipMaxWidth, placement, sx } = props;

  const [spanElement, setSpanElement] = useState<null | HTMLSpanElement>(null);

  return (
    <Tooltip
      title={
        spanElement && spanElement.scrollWidth > spanElement.clientWidth ? children : undefined
      }
      placement={placement}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: tooltipMaxWidth,
            textAlign: 'left',
          },
        },
      }}
    >
      <SpanWithEllipsis ref={setSpanElement} sx={sx}>
        {children}
      </SpanWithEllipsis>
    </Tooltip>
  );
}
